import React from 'react';
import { Tooltip, Typography } from '@mui/material';

const TruncatedText = ({ text = '', maxLength = 10, truncated = true, noTruncateText = "" }) => {
    let displayText;

    if (truncated && maxLength === -1) {
        // Take only the first word, handle null/undefined text
        displayText = text ? text.split(' ')[0] + '...' : '';
    } else if (truncated && text && text.length > maxLength) {
        // Truncate text if longer than maxLength, handle null/undefined text
        displayText = text ? text.substring(0, maxLength) + '...' : '';
    } else {
        displayText = text || '';
    }

    return (
        <Tooltip title={text || ''} arrow disableHoverListener={!truncated}>
            <Typography variant="body2" noWrap={truncated}>
                {noTruncateText} {displayText}
            </Typography>
        </Tooltip>
    );
};

export default TruncatedText;
